import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { WA_PHYSICS } from '../core/constants';
import { computeSafeSpawnPosition } from './spawnHelper';

export const WeaponBazooka: WeaponDefinition = {
  id: 'bazooka',
  name: 'Bazooka',
  icon: 'bazooka.png',
  category: 'projectile',
  maxAmmo: -1,
  maxUsesPerTurn: 1,
  powerCharging: true,
  timerAdjustable: false,
  showAimGuide: true,
  allowRetreat: false,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, angle, power, world } = ctx;

    const normalizedPower = power / 100;
    const speed = Math.log(normalizedPower * 9 + 1) * 300;
    const rad = (angle * Math.PI) / 180;

    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;

    const spawnDistance = 25;
    const spawn = computeSafeSpawnPosition(worm, aimRad, spawnDistance, world);

    const rocket = new Projectile({
      x: spawn.x,
      y: spawn.y,
      vx: Math.cos(aimRad) * speed,
      vy: -Math.sin(aimRad) * speed,
      type: 'bazooka',
      timer: -1,
      bounceH: 0,
      bounceV: 0,
      windAffected: true,
      explosionRadius: WA_PHYSICS.BAZOOKA.EXPLOSION_RADIUS,
      maxDamage: WA_PHYSICS.BAZOOKA.MAX_DAMAGE,
      ownerId: worm.id,
    });

    return {
      success: true,
      entities: [rocket],
    };
  },
};
